import React from 'react'

function Speciality() {
  return (
    <div>
      <div className="speciality-style-one-area default-padding-bottom">
        <div className="container">
          <div className="row align-center">
            <div className="col-lg-4">
              <img src="static/img/shape/1.jpg" alt="side-image" style={{ borderRadius: 30 + 'px' }} />

            </div>
            <div className="col-xl-7 offset-xl-1 col-lg-8 pt-lg-0  pt-120">
              <div className="speciality-items">
                <h4 className="sub-title">Our Goal</h4>
                <h2 className="title">
                  Your satisfaction is our top priority
                </h2>
                <div className="d-grid mt-40">
                  <ul className="list-style-two">
                    <li>Advanced Security </li>
                    <li>Multi-Platform</li>
                    <li>Future-Ready</li>
                    <li>Smart Features</li>
                  </ul>

                  <ul className="list-style-two">
                    <li>Growth-Ready </li>
                    <li>Effortless Sync</li>
                    <li>Intuitive UX</li>
                    <li>Clear Workflow</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Speciality
